import { Inject, Injectable } from '@angular/core';
import {
  BulkEntityService,
  Change,
  ConnectionHttpService,
  Dictionary,
  LazySaveResult,
  SOFTLINE_SERVICE_HTTP,
  SoftlineEntityService
} from '@softline/core';
import { Product } from '../data/product';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  SOFTLINE_API_KUNDEN_KONDITIONSLISTE_LIST,
  SOFTLINE_API_KUNDEN_KONDITIONSLISTE_INSERT
} from '../kunde-konditionliste.api';

@Injectable()
export class KundenKonditionslisteService extends SoftlineEntityService<Product, any> implements BulkEntityService<Product> {

  constructor(@Inject(SOFTLINE_SERVICE_HTTP) protected override service: ConnectionHttpService) {
    super(service, SOFTLINE_API_KUNDEN_KONDITIONSLISTE_LIST);
  }

  // TODO: remove this after API drops the 'conditionSheets' wrapper from the response
  // loadMany(params: any): Observable<Product[]> {
  //   return this.service.get<any, Product[]>({path: this.path, ...params}).pipe(
  //     map(o => o?.conditionSheets ?? [])
  //   );
  // }

  createOrUpdate(entity: Product |  Omit<Product, 'id'>): Observable<Product[]> {
    return this.service.create<any, Product | Product[]>({ path: SOFTLINE_API_KUNDEN_KONDITIONSLISTE_INSERT }, entity).pipe(
        map(result => Array.isArray(result) ? result : [result]),
        filter(o => !!o)
    );
  }

  override save(changes: Readonly<Change<Product>[]>, pathParams?: Dictionary<unknown>): Observable<LazySaveResult<Product>> {
    return this.service.create<any, Product[]>(
      { path: SOFTLINE_API_KUNDEN_KONDITIONSLISTE_INSERT },
      changes.map(o => (o.action === 'create' || o.action === 'update') ? o.entity : undefined)
    ).pipe(
      map((response: Product[]) => ({ failed: [], succeeded: response.map(o => ({ action: 'update', entity: o })) }))
    );
  }

}

/*
  user: d.steibl
  pass: Softline$12

  http://testsrv01:8079/restapi/api/v1/condition_sheet/list?valid_from=2022-01-04
 */
